import React from 'react';
import PropTypes from 'prop-types';

import { Collapse as MuiCollapse } from '@material-ui/core';

const Collapse = ({ children, ...rest }) => {
  return (
    <MuiCollapse
      {...rest}
    >
      { children }
    </MuiCollapse>
  )
}

Collapse.defaultProps = {
  children: null,
}

Collapse.propTypes = {
  children: PropTypes.node,
}

export default Collapse;



// WEBPACK FOOTER //
// ./src/components/base/Collapse/Collapse.js